class SNewsletterNudge extends HTMLElement {
  connectedCallback() {
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.button = this.querySelector('button');
    const schedule = (delay = 30000 + Math.random() * 25000) => {
      this.timer = setTimeout(() => {
        if (!this.isConnected) return;
        const dialogOpen = document.querySelector('dialog[open]');
        if (!this.motion.matches && !document.hidden && !dialogOpen && !this.button.matches(':hover, :focus-visible')) {
          const shine = this.querySelector('[data-newsletter-shine]');
          if (shine) this.animation = shine.animate([
            { transform: 'translateX(-200%) skewX(-20deg)', opacity: 0 },
            { opacity: 0.85, offset: 0.2 },
            { opacity: 0.85, offset: 0.7 },
            { transform: 'translateX(500%) skewX(-20deg)', opacity: 0 }
          ], { duration: 1200, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
        }
        schedule();
      }, delay);
    };
    this.onMotion = () => { if (this.motion.matches) this.animation?.cancel(); };
    this.motion.addEventListener('change', this.onMotion);
    schedule(3000);
    this.setupAutoOpen();
  }
  setupAutoOpen() {
    const dialog = document.getElementById('newsletter-overlay');
    if (!dialog || this.hasAttribute('data-no-auto-open')) return;
    const shownKey = 'xh-newsletter-shown';
    const startKey = 'xh-newsletter-visit-start';
    let visitStart;
    try {
      if (sessionStorage.getItem(shownKey)) return;
      visitStart = Number(sessionStorage.getItem(startKey)) || Date.now();
      sessionStorage.setItem(startKey, String(visitStart));
    } catch { return; }
    this.autoAbort = new AbortController();
    const markShown = () => {
      clearTimeout(this.autoTimer);
      try { sessionStorage.setItem(shownKey, '1'); } catch { /* Storage may become unavailable. */ }
    };
    dialog.addEventListener('toggle', () => {
      if (dialog.open) markShown();
    }, { signal: this.autoAbort.signal });
    dialog.addEventListener('command', event => {
      if (event.command === 'show-modal') markShown();
    }, { signal: this.autoAbort.signal });
    const openWhenReady = () => {
      if (!this.isConnected) return;
      if (dialog.open) { markShown(); return; }
      if (document.hidden || document.querySelector('dialog[open]')) {
        this.autoTimer = setTimeout(openWhenReady, 1000);
        return;
      }
      dialog.showModal();
      markShown();
    };
    if (dialog.open) { markShown(); return; }
    // Speed (merchant Nov 3, PageSpeed LCP 5.2 s on mobile): the popup waits for the visitor's first scroll, tap or key
    // after the 5 s, so it never counts as the page's largest paint (LCP stops at the first interaction).
    let interacted = false;
    let due = false;
    const onInteract = () => {
      if (interacted) return;
      interacted = true;
      if (due) openWhenReady();
    };
    for (const type of ['scroll', 'pointerdown', 'keydown', 'touchstart', 'wheel']) {
      window.addEventListener(type, onInteract, { signal: this.autoAbort.signal, passive: true, once: true });
    }
    this.autoTimer = setTimeout(() => {
      due = true;
      if (interacted) openWhenReady();
    }, Math.max(0, 5000 - (Date.now() - visitStart)));
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    clearTimeout(this.autoTimer);
    this.autoAbort?.abort();
    this.animation?.cancel();
    this.motion?.removeEventListener('change', this.onMotion);
  }
}
if (!customElements.get('s-newsletter-nudge')) customElements.define('s-newsletter-nudge', SNewsletterNudge);
